import { ReactComponent as PickersLogo } from "../../assets/pickers-logo.svg";
import { ReactComponent as PickersLogoMobile } from "../../assets/small-cangaroo.svg";
import "./navbar.scss";
import "./i18n";
import { useTranslation } from "react-i18next";

const Navbar = () => {
  const { t } = useTranslation();

  const scrollToFaq = () => {
    const faqSection = document.getElementById("faq-section");
    const rect = faqSection?.getBoundingClientRect();
    window.scroll({
      top: rect?.top,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="navbar-container" id="navbar">
      <div className="navbar-content">
        <div className="navbar-content-row">
          <div className="navbar-content-col-2 logo">
            <PickersLogo />
          </div>
          <div className="navbar-content-col-2 logo-mobile">
            <PickersLogoMobile />
          </div>
          <div className="navbar-content-col-3 faq-button-container">
            <button onClick={() => scrollToFaq()} className="faq">
              {t("navbar:faq")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
